<mat-dialog-content>
  <div *ngIf="data" class="esim-details-container">
    
    <!-- Información básica -->
    <mat-card class="details-card">
      <mat-card-header>
        <mat-card-title>{{ 'BACKOFFICE.USERS.ESIM_DETAILS.BASIC_INFO' | translate }}</mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <div class="info-grid">
          <div class="info-item">
            <strong>{{ 'BACKOFFICE.USERS.ESIM_LIST.TYPE' | translate }}:</strong>
            <span>{{ data.type }}</span>
          </div>
          <div class="info-item">
            <strong>{{ 'BACKOFFICE.USERS.ESIM_LIST.ICCID' | translate }}:</strong>
            <span>{{ data.iccid }}</span>
          </div>
          <div class="info-item">
            <strong>{{ 'BACKOFFICE.USERS.ESIM_LIST.COUNTRY' | translate }}:</strong>
            <span>{{ data.country }}</span>
          </div>
          <div class="info-item">
            <strong>{{ 'BACKOFFICE.USERS.ESIM_LIST.OPERATOR' | translate }}:</strong>
            <span>{{ data.operator }}</span>
          </div>
          <div class="info-item">
            <strong>{{ 'BACKOFFICE.USERS.ESIM_LIST.STATUS' | translate }}:</strong>
            <div>
              <span class="status-badge inline-block px-2 py-1 rounded-full text-xs font-medium {{ getStatusColor(data.status) }}">
                {{ data.status }}
              </span>
            </div>
          </div>
        </div>
      </mat-card-content>
    </mat-card>

    <!-- Fechas -->
    <mat-card class="details-card">
      <mat-card-header>
        <mat-card-title>{{ 'BACKOFFICE.USERS.ESIM_DETAILS.DATES' | translate }}</mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <div class="info-grid">
          <!-- Purchase Date - Always shown -->
          <div class="info-item" *ngIf="data.purchaseDate">
            <strong>{{ 'BACKOFFICE.USERS.ESIM_LIST.PURCHASE' | translate }}:</strong>
            <span>{{ data.purchaseDate | date:'dd/MM/yyyy' }}</span>
          </div>

          <!-- Activation Date - For ACTIVE, FINISHED, EXPIRED -->
          <div class="info-item" *ngIf="shouldShowActivationDate()">
            <strong>{{ 'BACKOFFICE.USERS.ESIM_LIST.ACTIVATION' | translate }}:</strong>
            <span>{{ data.activationDate | date:'dd/MM/yyyy' }}</span>
          </div>

          <!-- Expiry Date - For ACTIVE eSIMs -->
          <div class="info-item" *ngIf="shouldShowExpiryDate()">
            <strong>{{ 'BACKOFFICE.USERS.ESIM_LIST.EXPIRATION' | translate }}:</strong>
            <span>{{ data.expiryDate | date:'dd/MM/yyyy' }}</span>
          </div>

          <!-- Finish Date - For FINISHED eSIMs -->
          <div class="info-item" *ngIf="shouldShowFinishDate()">
            <strong>{{ 'BACKOFFICE.USERS.ESIM_DETAILS.FINISH_DATE' | translate }}:</strong>
            <span>{{ data.finishDate | date:'dd/MM/yyyy' }}</span>
          </div>

          <!-- Expired Date - For EXPIRED eSIMs -->
          <div class="info-item" *ngIf="shouldShowExpiredDate()">
            <strong>{{ 'BACKOFFICE.USERS.ESIM_DETAILS.EXPIRED_DATE' | translate }}:</strong>
            <span>{{ data.expiredDate | date:'dd/MM/yyyy' }}</span>
          </div>

          <!-- Recycling Deadline - For NOT_ACTIVE eSIMs (calculated) -->
          <div class="info-item" *ngIf="shouldShowRecyclingDeadline()">
            <strong>{{ 'BACKOFFICE.USERS.ESIM_DETAILS.RECYCLING_DEADLINE' | translate }}:</strong>
            <span>{{ data.recyclingDeadlineDate | date:'dd/MM/yyyy' }}</span>
          </div>

          <!-- Recycled Date - For RECYCLED eSIMs -->
          <div class="info-item" *ngIf="shouldShowRecycledDate()">
            <strong>{{ 'BACKOFFICE.USERS.ESIM_DETAILS.RECYCLED_DATE' | translate }}:</strong>
            <span>{{ data.recycledDate | date:'dd/MM/yyyy' }}</span>
          </div>
        </div>
      </mat-card-content>
    </mat-card>

    <!-- Consumo -->
    <mat-card class="details-card" *ngIf="shouldShowUsageCard()">
      <mat-card-header>
        <mat-card-title>{{ 'BACKOFFICE.USERS.ESIM_DETAILS.USAGE' | translate }}</mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <div class="consumption-container">
          
          <!-- Voz -->
          <div class="consumption-item" *ngIf="shouldShowVoiceUsage()">
            <div class="consumption-header">
              <span class="consumption-label">{{ 'BACKOFFICE.USERS.ESIM_LIST.VOICE' | translate }}</span>
              <span class="consumption-value">{{ data.voiceUsed }} / {{ data.voiceLimit }} ({{ getUsagePercentage(data.voiceUsed, data.voiceLimit) }}%)</span>
            </div>
            <mat-progress-bar
              mode="determinate"
              [value]="getUsagePercentage(data.voiceUsed, data.voiceLimit)"
              class="consumption-progress">
            </mat-progress-bar>
          </div>

          <!-- Mensajes -->
          <div class="consumption-item" *ngIf="shouldShowTextUsage()">
            <div class="consumption-header">
              <span class="consumption-label">{{ 'BACKOFFICE.USERS.ESIM_LIST.MESSAGES' | translate }}</span>
              <span class="consumption-value">{{ data.textUsed }} / {{ data.textLimit }} ({{ getUsagePercentage(data.textUsed, data.textLimit) }}%)</span>
            </div>
            <mat-progress-bar
              mode="determinate"
              [value]="getUsagePercentage(data.textUsed, data.textLimit)"
              class="consumption-progress">
            </mat-progress-bar>
          </div>

          <!-- Datos -->
          <div class="consumption-item" *ngIf="shouldShowDataUsage()">
            <div class="consumption-header">
              <span class="consumption-label">{{ 'BACKOFFICE.USERS.ESIM_LIST.DATA' | translate }}</span>
              <span class="consumption-value">{{ data.dataUsed }} / {{ data.dataLimit }} ({{ getUsagePercentage(data.dataUsed, data.dataLimit) }}%)</span>
            </div>
            <mat-progress-bar
              mode="determinate"
              [value]="getUsagePercentage(data.dataUsed, data.dataLimit)"
              class="consumption-progress">
            </mat-progress-bar>
          </div>

        </div>
      </mat-card-content>
    </mat-card>

  </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-raised-button color="primary" (click)="openEsimDetails()">{{ 'BACKOFFICE.USERS.ESIM_DETAILS.VIEW_DETAILS' | translate }}</button>
  <button mat-button (click)="onClose()">{{ 'BACKOFFICE.USERS.ESIM_DETAILS.CLOSE' | translate }}</button>
</mat-dialog-actions>
